import { StateSchema } from 'app/config/storeConfig/types';
import { AuthFormMode } from '../types';

export const getAuthFormMode = (state: StateSchema): AuthFormMode => state.authForm.mode;
